import { getCountries } from "react-phone-number-input";
import { useConfig } from "../../../../../providers/useConfig";
export const useAvailableCountries = () => {
    const config = useConfig();
    const allCountries = getCountries();
    return config.internationalPhoneCountriesInDropdown.length
        ? config.internationalPhoneCountriesInDropdown
        : allCountries;
};
//# sourceMappingURL=useAvailableCountries.js.map